
import { modalSet} from "_slices/view";
import { useDispatch } from "react-redux";
import { openModalAction } from "_slices/modal";
import { useEffect, useState } from "react";
import miscEvent from 'lib/ga/miscEvent';
import { checkLoggedIn } from "context/context";
import { useRouter } from 'next/navigation'
import styles from './agents.module.css';
import globalStyles from '../result.module.css';
  
interface Props {
  agents: any;
  contactable: boolean
  sponsored: boolean
  title: string,
  id: number,
  type: string,
  display: string,
  showAllAgentContacts: boolean,
}
const AgentsList = ({ agents, contactable, title, sponsored, id, type, display, showAllAgentContacts = false }: Props) => {
  if (!agents) return null;
  return (
    <div id="agent-contain" className={`${styles.GridContainer} ${styles.marginBottom}`}>
      <div className={styles.gridRow}>
        <h2 className={globalStyles.subTitleText}>{title || 'Agents'}</h2>
      </div>
      <div className={styles.contentRow}>
        {agents.map((agent) => {
          return (
            <AgentListItem showAllAgentContacts={showAllAgentContacts} key={agent.company_id} company={agent} contactable={contactable} sponsored={sponsored} id={id} type={type} display={display} />
          );
        })}
      </div>
    </div>
  );
};

export default AgentsList;

type DisplayAgentPros = {
  title: string,
  agent: object,
  company: object,
  sponsored: boolean,
  active: number
}

const Agent = ({ agent, company, sponsored, id, type }) => {
  const loggedIn = checkLoggedIn();
  const [displayAgentsProps, setDisplayAgentsProps] = useState<DisplayAgentPros | null>(null);
  const router = useRouter();
  useEffect(() => {
    if (loggedIn && displayAgentsProps !== null) {
      dispatch(
        openModalAction({
          componentName: "AgentContactInfomation",
          componentProps: displayAgentsProps,
        })
      );
    }
  }, [loggedIn, displayAgentsProps]);

  let ModalTitle = "Call Agent";
  if (agent.repType == "asset_manager") {
    ModalTitle = "Contact Asset Manager"
  }
  if (agent.repType == "centre_manager") {
    ModalTitle = "Contact Centre Manager"
  }
  if (agent.repType == "owner") {
    ModalTitle = "Contact Owner"
  }

  let contacts = agent.contacts.filter(contact => contact.location !== '');
  let dispatch = useDispatch();
  return (
    <div className={styles.agentContainer} >
      <div className={styles.agentDetails}>
        <p className={globalStyles.mediumText} >
          {`${agent.forename} ${agent.surname}`}
        </p>
      </div>
      <div className={styles.buttonContainer}>
        {contacts.length > 0 && (
          <button className={styles.callButton}
            onClick={() => {
              if (loggedIn) {
                dispatch(
                  openModalAction({
                    componentName: "AgentContactInfomation",
                    componentProps: {
                      title: ModalTitle,
                      agent: agent,
                      company: company,
                      active: id,
                      sponsored: sponsored,
                      type: type
                    },
                  })
                );
              } else {
                dispatch(
                  modalSet({
                    visible: true,
                    type: "auth",
                    view: "login",
                    router,
                    propertyPage: true
                  })
                );
                setDisplayAgentsProps({
                  title: ModalTitle,
                  agent: agent,
                  company: company,
                  sponsored: sponsored,
                  active: id,
                })
              }
            }}
          >
            {agent.repType == 'agent' ? 'Call' : 'Contact'}
          </button>
        )}

      </div>
    </div>
  );
};

const Company = ({ company, isOpen, contactable }) => {

  let hasAgents = company?.users?.length > 0
  return (
    <div className={hasAgents && contactable ? `${styles.companyContainer} ${styles.contactable}` : styles.companyContainer}>
      <div className={styles.companyLogo}>
        {company.logo_uri &&
          <img alt={`${company.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${company.logo_uri}`} loading="lazy" height="auto" width="auto"></img>}
      </div>
      <div className={styles.agentDetails}>
        <p className={globalStyles.largeText}>{company.company_name}</p>
      </div>
      {hasAgents && contactable && <div className={styles.plusContainer}>
        {isOpen ? <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/cross-grey-2.svg`} alt="cross icon" width="12" height="12"></img> : <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/plus-grey.svg`} alt="plus icon" width="12" height="12"></img>}

      </div>}

    </div>
  );
};

const AgentListItem = ({ company, contactable, sponsored, id, type, display, showAllAgentContacts }) => {
  
  const [isOpen, setIsOpen] = useState<boolean>(false);
  let showAgents = true;
  if( display === 'agents') {
    showAgents = contactable || company.paying_client;
  }
  const onOpen = () => {
   if (display !== 'agents' ) {
      if (!isOpen) {
        const log = {
          event: 'show_contacts',
          result_id: id,
          type,
          display,
          company_id: company.company_id,
        }
        miscEvent(log)
  
      }
      setIsOpen(!isOpen);
    }
  }

  useEffect(() => {
    setIsOpen(showAllAgentContacts)
  }, [showAllAgentContacts])

  return (
    <div className={styles.agentSlideContainer}>
      <div className={styles.companyPadder} onClick={onOpen}>
        <Company company={company} isOpen={isOpen} contactable={display === 'agents' ? false : showAgents} />
      </div>
      {showAgents && <div className={isOpen ? `${styles.agentList} ${styles.open}` : `${styles.agentList} ${styles.close}`}>
        {company.users.map((agent, i) => {
          return <Agent key={i} agent={agent} company={company} sponsored={sponsored} id={id} type={type} />;
        })}
      </div>}
    </div>
  );
};
